<template lang="en">
<div class="doctor-profile">
    <Navigation></Navigation>
    <!-- <div id="breadcrumb">
        <div class="container">
            <ul>
                <li><a href="#">Inicio</a></li>
                <li><a href="#">Category</a></li>
                <li>Page active</li>
            </ul>
        </div>
    </div> -->
    <!-- /breadcrumb -->

    <Loader :show="loading" type="inline"></Loader>

    <div class="container margin_60" v-if="!loading">
        <div class="row">

            <aside class="col-12 col-lg-3" id="sidebar" >
                <div class="box_profile">

                    <div class="box_profile_image">
                        <figure class="mb-2">
                            <div class="avatar" v-if="medic.picture" :style="'background-image:url('+API_URL+medic.picture.urlThumb+')'"></div>
                            <div class="avatar" v-if="!medic.picture && medic.gender=='female'" :style="'background-image:url('+require('@/assets/img/no-avatar-image-female.jpg')+')'"></div>
                            <div class="avatar" v-if="!medic.picture && medic.gender=='male'" :style="'background-image:url('+require('@/assets/img/no-avatar-image-male.jpg')+')'"></div>

                        </figure>
                    </div>

                    <div class="box_profile_info pb-3">
                        <div class="especialities">
                            <small  v-for="medicEspeciality in medic.medicEspecialities" :key="medicEspeciality.id">
                                {{medicEspeciality.especiality.name}}
                            </small>
                        </div>
                    
                        <h1>{{medic.fullname}}</h1>
						
						<div v-if="medic.rate>0">
							<star-rating :star-size="14" :read-only="true" :show-rating="false" :rating="medic.rate"  inactive-color="#ddd" :inline="true"></star-rating>
						</div>

                        <ul class="contacts" v-if="medic.medicBusinessAddresses.length>0">
                            <li v-for="address in medic.medicBusinessAddresses">
                                <h6>Ubicación</h6>{{address.locality.name}}, {{address.locality.region.name}}
                            </li>
                        </ul>
                        
                        <div class="">
                            <table class="table table-sm table-borderless services-table">
                                <thead>
                                    <tr>
                                        <th>Servicio</th>
                                        <th>Precio</th>
                                    </tr>
                                </thead>
                                <tbody v-for="medicEspeciality in medic.medicEspecialities" :key="medicEspeciality.id">
                                    <tr v-if="medicEspeciality.channel_presential">
                                        <td class="text-left">
                                            {{medicEspeciality.especiality.name}}<br>
                                            Presencial
                                        </td>
                                        <td>${{medicEspeciality.price}}</td>
                                    </tr>
                                    <tr v-if="medicEspeciality.channel_video">
                                        <td class="text-left">
                                            {{medicEspeciality.especiality.name}}<br>
                                            VideoConsulta
                                        </td>
                                        <td>${{medicEspeciality.price_video}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="d-flex">
                            <div class="donator-stamp" v-if="medic.isDonator"></div>
                            <a :href="'http://'+medic.linkedIn" target="_blank" class="btn-linkedIn" v-if="medic.linkedIn"></a>

                        </div>



                        <div v-for="clinic in medic.clinics" :key="clinic.id" class="mt-2 mb-2">
                            <img v-if="clinic.logo" :src="API_URL+clinic.logo.urlThumb" class="clinic-image img-fluid">
                        </div>


                    </div>


                </div>
            </aside>
            <!-- /asdide -->

            <div class="col-md-12 col-lg-9 ">

                <div class="tabs_styled_2">
                    <ul class="nav nav-tabs" role="tablist">
                        <li class="nav-item">
                            <div class="nav-link" @click="selectedtab='booking'" :class="{'active':selectedtab=='booking'}">Reservar hora</div>
                        </li>
                        <li class="nav-item">
                            <div class="nav-link" @click="selectedtab='general'" :class="{'active':selectedtab=='general'}" >Formación</div>
                        </li>
                        <!-- <li class="nav-item">
                            <div class="nav-link"@click="selectedtab='reviews'" :class="{'active':selectedtab=='reviews'}" >Reseñas</div>
                        </li> -->
                    </ul>
                    <!--/nav-tabs -->

                    <div class="tab-content">

                        <div class="tab-pane fade show" :class="{'active':selectedtab=='booking'}">
                            
                            <div class="alert alert-warning" v-if="purchase.coupon && requestHours">
                                El médico no cuenta con horas disponibles en este momento. Ya lo hemos notificado, para que actualice su agenda y puedas reservar tu consulta.
                            </div>

                            <div class="col-md-12" v-if="requestHours" >
                                <div class="alert alert-warning" >
                                    <h4>Upss! <small>Lamentablemente el médico no cuenta con horas disponibles en este momento.</small></h4>
                                    Completa el siguiente formulario para notificarnos e intentaremos conseguirte la consulta que estás buscando.<br>

                                    <ContactForm 
                                        class="mt-4" 
                                        subject="UPS - Busqueda vacia"
                                        @sended="createEmptyScheduleNotification()"
                                        >
                                    </ContactForm>

                                </div>
                            </div>

                            <form v-if="!requestHours">

                                <div class="main_title_3">
                                    <h3><strong>1</strong> SELECCIONÁ LA HORA</h3>
                                </div>

                                <Calendar 
                                    v-if="medic.id" 
                                    type='0'
                                    :medicId="medic.id" 
                                    :selectedDatetime="selectedDatetime"
                                    @selected="selectHour"></Calendar>


                                <div v-if="purchase.slot.id && purchase.especiality && !$route.query.especiality && medicEspecialities.length>1">
                                    <div class="main_title_3" >
                                        <h3><strong>2</strong>Seleccioná la especialidad </h3>
                                    </div>
                                    <ul class="treatments clearfix m-0">
                                        <li  v-for="medicEspeciality in medicEspecialities" :key="medicEspeciality.id">
                                            <div class="custom-control custom-radio">
                                                <input type="radio" 
                                                    name="especiality" 
                                                    class="custom-control-input" 
                                                    :id="'especiality'+medicEspeciality.id" 
                                                    :checked="purchase.especiality==medicEspeciality"
                                                    >
                                                <label 
                                                    class="custom-control-label" 
                                                    :for="'especiality'+medicEspeciality.id"
                                                    @click="selectEspeciality(medicEspeciality)"
                                                    >
                                                    Consulta de {{medicEspeciality.especiality.name}}
                                                    <!-- <strong v-if="purchase.coupon" class="text-success">$ 0</strong> -->
                                                    <!-- <strong v-else>${{medicEspeciality.price_video}}</strong> -->
                                                </label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                
                                <div v-if="purchase.slot.id && purchase.especiality && channelsActive.presential && channelsActive.video && purchase.slot.channel == 'mix'">
                                    <div class="main_title_3" >
                                        <h3>
                                            <strong v-if="purchase.slot.id && purchase.especiality && !$route.query.especiality && medicEspecialities.length>1">3</strong>
                                            <strong v-else>2</strong>
                                            Seleccionar canal de atención </h3>
                                    </div>
                                    <ul class="treatments clearfix m-0">
                                        <li >
                                            <div class="custom-control custom-radio">
                                                <input type="radio" 
                                                    name="channel" 
                                                    class="custom-control-input" 
                                                    :id="'channel-video'" 
                                                    :checked="purchase.channel=='video'"
                                                    >
                                                <label 
                                                    class="custom-control-label" 
                                                    :for="'channel-video'"
                                                    @click="selectChannel('video')"
                                                    >
                                                    VideoConsulta
                                                    <strong v-if="purchase.coupon" class="text-success">$ 0</strong>
                                                    <strong v-else>${{purchase.especiality.price_video}}</strong>
                                                </label>
                                            </div>
                                            
                                        </li>
                                        <li >
                                            <div class="custom-control custom-radio">
                                                <input type="radio" 
                                                    name="channel" 
                                                    class="custom-control-input" 
                                                    :id="'channel-presential'" 
                                                    :checked="purchase.channel=='presential'"
                                                    >
                                                <label 
                                                    class="custom-control-label" 
                                                    :for="'channel-presential'"
                                                    @click="selectChannel('presential')"
                                                    >
                                                    Consulta Presencial
                                                    <strong v-if="purchase.coupon" class="text-success">$ 0</strong>
                                                    <strong v-else>${{purchase.especiality.price}}</strong>
                                                </label>
                                            </div>
                                            
                                        </li>
                                    </ul>
                                </div>

                                <div class="main_title_3 mt-4" v-if="medic.medicBusinessAddresses.length>1" >
                                    <h3><strong>3</strong>Seleccioná la ubicación</h3>
                                </div>
                                <ul class="treatments clearfix m-0" v-if="medic.medicBusinessAddresses.length>1">
                                    <li  v-for="address in medic.medicBusinessAddresses" :key="address.id">
                                        <div class="custom-control custom-radio ">
                                            <input type="radio" 
                                                name="address" 
                                                class="custom-control-input" 
                                                :id="'address'+address.id" 
                                                :checked="purchase.address.id==address.id"
                                                >
                                            <label 
                                                class="custom-control-label" 
                                                :for="'address'+address.id"
                                                @click="selectAddress(address)"
                                                >
                                                {{address.locality.name}}, {{address.locality.region.name}}
                                            </label>
                                        </div>
                                    </li>
                                </ul>

                            </form>
                            <hr>

                            <div class="alert alert-danger" v-if="purchaseFieldsError">
                                Seleccione un horario y una especialidad para continuar.
                            </div>

                            <div class="donator-badge mt-3 mb-3" v-if="medic.isDonator && purchase.coupon">
                                <div class="stamp-content">
                                    Está realizando una reserva gratuita a traves del sistema gratia 
                                </div>
                            </div>

                            <div class="text-center" v-if="purchase.slot.id && purchase.especiality.id && purchase.channel">
                                <button class="btn_1 medium"
                                    @click="confirmPurchase"
                                    >Continuar <span v-if="purchase.especiality.id>0 && !purchase.coupon">( $ {{purchase.price }} )</span>
                                </button>
                            </div>

                            <!-- <pre>{{purchase}}</pre> -->


                        </div>
                        <!-- /tab_1 -->

                        <div class="tab-pane fade show" :class="{'active':selectedtab=='general'}">
                            
                                
                            <div class="indent_title_in">
                                <i class="pe-7s-study"></i>
                                <h3>Educación</h3>
                                <!-- <p>Mussum ipsum cacilds, vidis litro abertis.</p> -->
                            </div>
                            <div class="wrapper_indent">
                                <p>
                                    {{medic.education_review}}
                                </p>
                                
                                <!-- /especialidades -->
                                <div v-for="medicEspeciality in medic.medicEspecialities" :key="medicEspeciality.id" class="especiality-item mt-3">
                                    <div class="indent_title_in mb-1">
                                        <i class="pe-7s-news-paper"></i>
                                        {{medicEspeciality.especiality.name}} | {{medicEspeciality.university}}
                                        <h3>{{medicEspeciality.title}}</h3>
                                        <!-- <p>Datos como experiencia, grado, etc...</p> -->
                                    </div>
                                    <div class="wrapper_indent">
                                        <p>{{medicEspeciality.description}}</p>
                                        <h6 v-if="medicEspeciality.medicSubespecialities.length>0">Especializaciones</h6>
                                        <div class="row" v-if="medicEspeciality.medicSubespecialities.length>0">
                                            <div class="col-lg-6">
                                                <ul class="bullets">
                                                    <li v-for="medicSubespeciality in medicEspeciality.medicSubespecialities">
                                                        {{medicSubespeciality.subespeciality.name}}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- /especialidades -->

                            </div>

                            

                        </div>
                        <!-- /tab_2 -->

                        <div class="tab-pane fade show" :class="{'active':selectedtab=='reviews'}">
                            <MedicValorations :id="medic.id" v-if="selectedtab=='reviews'"></MedicValorations>
                        </div>

                    </div>
                    <!-- /tab-content -->
                </div>
                <!-- /tabs_styled -->
            </div>
            <!-- /col -->
        </div>
        <!-- /row -->
    </div>

    <b-modal id="modal-login" size="sm" centered  hide-footer hide-header>
        <LoginBox @logged="closeLoginModal"></LoginBox>
    </b-modal>
    

    <Footer :shareTitle="`${medic.fullname} está esperando que coordines tu consulta en DoctorConsultas`"></Footer>

</div>
</template>

<script>
import gql from 'graphql-tag'
import { mapGetters, mapMutations } from 'vuex'

import Navigation from '@/components/Navigation'
import Footer from '@/components/Footer'
import ListSchedule from '@/components/ListSchedule'
import Loader from '@/components/Loader'
import MedicValorations from '@/components/MedicValorations'
import Calendar from '@/components/Calendar'
import LoginBox from '@/components/LoginBox'
import ContactForm from '@/components/ContactForm'

export default {
	name: 'DoctorProfile',
	metaInfo() {
		return {
			title: this.medic.fullname,
		}
	},
	components: {
		Navigation,
		Footer,
		ListSchedule,
		Loader,
		MedicValorations,
		Calendar,
		LoginBox,
		ContactForm,
	},
	computed: {
		...mapGetters(['isAuthenticated', 'loggedUser']),
	},
	data() {
		return {
			API_URL: process.env.VUE_APP_API_URL,
			medic: {},
			loading: true,
			id: this.$route.params.id,
			selectedtab: 'booking',
			steps: 1,
			purchase: {
				slot: {},
				especiality: {},
				coupon: null,
				channel: null,
				price: null,
			},
			purchasing: false,
			purchaseFieldsError: false,
			selectedParamsEspeciality: this.$route.params.especiality,
			selectedParamsDatetime: this.$route.params.datetime,
			selectedDatetime: null,
			medicEspecialities: [],
			channelsActive: {
				presential: false,
				video: false,
			},
			requestHours: false,
			// selectedChannel:null,
		}
	},
	beforeMount() {},
	apollo: {
		medic: {
			query: gql`
				query getMedic($id: ID!) {
					medic(id: $id) {
						id
						fullname
						prefix
						birthdate
						gender
						cjp
						personal_review
						education_review
						picture {
							urlThumb
						}
						linkedIn
						hasAvailableTimeslots
						isDonator
						medicEspecialities {
							id
							title
							university
							description
							price
							price_video
							channel_video
							channel_presential
							status
							especiality {
								name
								slug
							}
							medicSubespecialities {
								subespeciality {
									name
								}
							}
						}
						medicBusinessAddresses {
							id
							locality {
								name
								region {
									name
								}
							}
						}
						clinics {
							id
							name
							logo {
								urlThumb
							}
						}
						rate
						nextAvailability {
							datetime
						}
						nextVideoAvailability {
							datetime
						}
						hasChannelPresential
						hasChannelVideo
						is_completed
						status
					}
				}
			`,
			variables() {
				return {
					count: 5,
					id: this.id,
				}
			},
			result(data) {
				this.loading = false
				this.medic = data.data.medic
				this.selectePreselectedData()
				this.ifHasHoursToBook(data.data.medic)

				if (this.$route.query.coupon) {
					this.validateCode(this.$route.query.coupon)
				}
			},
		},
	},
	methods: {
		...mapMutations(['storePurchase']),
		selectHour(selectedSlot) {
			this.purchase.slot = selectedSlot
			this.filterAndPreselectEspecialities()
			this.filterAndPreselectChannels()
		},
		selectEspeciality(selectedEspeciality) {
			this.purchase.especiality = selectedEspeciality
			this.filterAndPreselectChannels()
			this.calcPrice()
		},
		selectChannel(selectedChannel) {
			this.purchase.channel = selectedChannel
			this.calcPrice()
		},
		selectAddress(selectedAddress) {
			this.purchase.address = selectedAddress
		},

		filterAndPreselectEspecialities() {
			// muestro solo las especialidades que sean compatibles con el slot seleccionado
			this.medicEspecialities = []
			if (this.purchase.slot.channel == 'presential') {
				this.medic.medicEspecialities.forEach((medicEspeciality) => {
					if (medicEspeciality.channel_presential) {
						this.medicEspecialities.push(medicEspeciality)
					}
				})
			}
			if (this.purchase.slot.channel == 'video') {
				this.medic.medicEspecialities.forEach((medicEspeciality) => {
					if (medicEspeciality.channel_video) {
						this.medicEspecialities.push(medicEspeciality)
					}
				})
			}
			if (this.purchase.slot.channel == 'mix') {
				this.medicEspecialities = this.medic.medicEspecialities
			}

			// si queda una sola especialidad la selecciono.
			if (this.medicEspecialities.length == 1) {
				this.selectEspeciality(this.medicEspecialities[0])
			}
		},

		filterAndPreselectChannels() {
			// console.log('filterChannels', this.purchase.especiality, this.purchase.slot)
			// segun la especialidad seleccionada, dejo mostar la seleccion de diferentes canales si estan activos los dos
			this.channelsActive.presential = this.purchase.especiality.channel_presential
			this.channelsActive.video = this.purchase.especiality.channel_video

			if (this.purchase.slot.channel == 'mix') {
				if (this.purchase.especiality.channel_presential && !this.purchase.especiality.channel_video) {
					this.purchase.channel = 'presential'
				} else if (!this.purchase.especiality.channel_presential && this.purchase.especiality.channel_video) {
					this.purchase.channel = 'video'
				}
			} else {
				this.purchase.channel = this.purchase.slot.channel
			}
		},
		calcPrice() {
			if (this.purchase.especiality && this.purchase.channel) {
				if (this.purchase.channel == 'video') {
					this.purchase.price = this.purchase.especiality.price_video
				} else if (this.purchase.channel == 'presential') {
					this.purchase.price = this.purchase.especiality.price
				} else if (this.purchase.channel == 'mix') {
					if (this.purchase.especiality.channel_presential && !this.purchase.especiality.channel_video) {
						this.purchase.price = this.purchase.especiality.price
					} else {
						this.purchase.price = this.purchase.especiality.price_video
					}
				}
			}
			if (this.purchase.coupon) {
				this.purchase.price = 0
			}
			this.purchase.priceBase = this.purchase.price
		},
		selectePreselectedData() {
			if (this.$route.query.especiality) {
				if (this.medic.medicEspecialities.length > 0) {
					this.medic.medicEspecialities.forEach((medicEspeciality) => {
						if (medicEspeciality.especiality.slug == this.$route.query.especiality) {
							this.selectEspeciality(medicEspeciality)
						}
					})
				}
			}
			if (this.$route.query.channel) {
				this.selectChannel(this.$route.query.channel)
			}

			if (this.$route.query.datetime) {
				this.selectedDatetime = this.$route.query.datetime
			}

			if (this.medic.medicBusinessAddresses.length > 0) {
				this.selectAddress(this.medic.medicBusinessAddresses[0])
			}
		},
		ifHasHoursToBook(medic) {
			if (!this.medic.is_completed) {
				this.requestHours = true
			}
			if (!this.medic.status || this.medic.status == '0') {
				this.requestHours = true
			}
			if (this.$route.query.requestHours == 'video') {
				if (!medic.nextVideoAvailability) {
					this.requestHours = true
				}
			} else if (this.$route.query.requestHours == 'presential') {
				if (!medic.nextAvailability) {
					this.requestHours = true
				}
			} else {
				if (!medic.nextAvailability && !medic.nextVideoAvailability) {
					this.requestHours = true
				}
			}
		},
		confirmPurchase() {
			if (!this.purchasing) {
				
				this.purchaseFieldsError = false

				if (!this.purchase.slot.id || !this.purchase.especiality.id || !this.medic.id) {
					this.purchaseFieldsError = true
					return false
				}

				this.purchasing = true

				if (!this.isAuthenticated) {
					this.$bvModal.show('modal-login')
					this.purchasing = false
					return false
				}

				this.purchase.medic_id = this.medic.id
				this.storePurchase(this.purchase)
				this.$router.push('/checkout')
			}
		},
		closeLoginModal() {
			this.$bvModal.hide('modal-login')
		},
		validateCode(code) {
			console.log('validateCode')
			this.$apollo
				.query({
					query: gql`
						query medicCoupon($code: String, $status: Int) {
							medicCoupon(code: $code, status: $status) {
								id
								medic {
									id
								}
								code
							}
						}
					`,
					variables: {
						status: 1,
						code: code,
					},
				})
				.then((data) => {
					if (data.data.medicCoupon && data.data.medicCoupon.id > 0) {
						if (data.data.medicCoupon.medic.id === this.medic.id) {
							this.purchase.coupon = data.data.medicCoupon.code

							this.createNotAvailabilityNotification(this.medic)
						}
					}
				})
		},
		createNotAvailabilityNotification(medic) {
			console.log('createNotAvailabilityNotification')
			if (this.requestHours) {
				var dataInput = {
					type: 'MEDIC_EMPTY_SCHEDULE',
					user_type: 'MEDIC',
					user_id: medic.id,
					subject: 'Actualizá tu agenda',
					message: `Un usuario ha intentado canjear uno de tus cupones de Gratia, pero tu perfil médico no cuenta con horas disponibles.<br>
                    Te rogamos que actualices tu agenda. <br>Gracias.<br>¡Saludos! El Equipo de DC.`,
				}
				this.$apollo.mutate({
					mutation: gql`
						mutation($data: NotificationInput!) {
							notificationCreate(data: $data) {
								id
							}
						}
					`,
					variables: {
						data: dataInput,
					},
				})
			}
		},

		createEmptyScheduleNotification() {
			console.log('createEmptyScheduleNotification')
			if (this.requestHours) {
				var dataInput = {
					type: 'EMPTY_SEARCH',
					user_type: 'MEDIC',
					user_id: this.medic.id,
					subject: 'Actualizá tu agenda',
					message: 'Actualizar agenda',
				}
				this.$apollo.mutate({
					mutation: gql`
						mutation($data: NotificationInput!) {
							notificationCreate(data: $data) {
								id
							}
						}
					`,
					variables: {
						data: dataInput,
					},
				})
			}
		},
	},
}
</script>

<style scoped>
.box_profile {
	background-color: #fff;
	text-align: center;
	-webkit-border-radius: 5px;
	-moz-border-radius: 5px;
	-ms-border-radius: 5px;
	border-radius: 5px;
	border: 1px solid #e1e8ed;
	margin-bottom: 35px;
	overflow: hidden;
}

.box_profile figure {
	margin: -1px -26px 0px -26px;
	-webkit-border-radius: 5px 5px 0 0;
	-moz-border-radius: 5px 5px 0 0;
	-ms-border-radius: 5px 5px 0 0;
	border-radius: 5px 5px 0 0;
	overflow: hidden;
}

.box_profile_image {
	width: 100%;
}
.box_profile_info {
	width: 100%;
	padding: 0 8px 0px 8px;
}

.box_profile .rating {
	margin-bottom: 20px;
	display: inline-block;
}

.box_profile small {
	text-transform: uppercase;
	color: #999;
	font-weight: 600;
}

.box_profile h1 {
	font-size: 21px;
	font-size: 1.3125rem;
}

.box_profile p {
	color: #999;
}

.box_profile ul.statistic {
	padding-bottom: 5px;
}

.box_profile ul.statistic li {
	display: inline-block;
	background-color: #74d1c6;
	-webkit-border-radius: 3px;
	-moz-border-radius: 3px;
	-ms-border-radius: 3px;
	border-radius: 3px;
	line-height: normal;
	color: #fff;
	padding: 3px 10px;
	font-weight: 600;
	font-size: 12px;
	font-size: 0.75rem;
	min-width: 95px;
}

.box_profile ul.contacts {
	text-align: center;

	border-top: 1px solid #ededed;
	border-bottom: 1px solid #ededed;
	padding: 12px;
	margin: 10px -25px 10px -25px;
}

.box_profile ul.contacts li {
	margin-bottom: 15px;
}

.box_profile ul.contacts li h6 {
	font-size: 14px;
	font-size: 0.875rem;
	margin-bottom: 3px;
}

.box_profile ul.contacts li:last-child {
	margin-bottom: 0;
}

.nav-tabs .nav-link {
	cursor: pointer;
}

.tabs_styled_2 .nav-tabs .nav-item.show .nav-link,
.tabs_styled_2 .nav-tabs .nav-link.active {
	color: #333333;
	background-color: #fff;
	border-color: #e1e8ed;
	border-bottom: 1px solid transparent;
	border-top: 2px solid #12bcec;
}

@media (max-width: 767px) {
	/* .tabs_styled_2 .nav-tabs .nav-item.show .nav-link,
    .tabs_styled_2 .nav-tabs .nav-link.active {
        border: 1px solid transparent;
    } */
}

.tabs_styled_2 .nav-tabs .nav-link:focus,
.tabs_styled_2 .nav-tabs .nav-link.active:hover {
	border-color: #e1e8ed;
	border-bottom: 1px solid transparent;
	border-top: 2px solid #12bcec;
}

@media (max-width: 767px) {
	/* .tabs_styled_2 .nav-tabs .nav-link:focus,
    .tabs_styled_2 .nav-tabs .nav-link.active:hover {
        
        border: 1px solid transparent;
    } */
}

.tabs_styled_2 .nav-tabs .nav-link:hover {
	border-color: transparent;
}

@media (max-width: 767px) {
	/* .tabs_styled_2 .nav-item {
        
        display: block;
        width: 100%;
        margin-bottom: 5px;
        border: 1px solid #e1e8ed;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        -ms-border-radius: 5px;
        border-radius: 5px;
    } */
}

.tabs_styled_2 .nav-tabs .nav-link {
	border-top-left-radius: 3px;
	border-top-right-radius: 3px;
	font-size: 16px;
	font-size: 1rem;
	padding: 0.75rem 1.5rem;
	margin-right: 5px;
}

@media (max-width: 767px) {
	.tabs_styled_2 .nav-tabs .nav-link {
		/* For less than 767px */
		margin-right: 0;
		padding: 0.5rem;
	}
}

.tabs_styled_2 .nav-tabs {
	border-bottom: 1px solid #e1e8ed;
}

.tabs_styled_2 .tab-pane {
	background-color: #fff;
	padding: 30px 30px 20px 30px;
	border: 1px solid #e1e8ed;
	border-top: none;
}

.tabs_styled_2 .tab-pane hr {
	margin: 30px -30px 30px -30px;
	border-color: #ededed;
}

.main_title_3 {
	background-color: #12bcec;
	-webkit-border-radius: 5px;
	-moz-border-radius: 5px;
	-ms-border-radius: 5px;
	border-radius: 5px;
	text-align: center;
	padding: 10px;
	position: relative;
	margin-bottom: 10px;
}
@media (max-width: 991px) {
	.main_title_3 {
		/* For less than 991px */
		margin-bottom: 30px;
	}
}
.main_title_3 h3 {
	font-size: 16px;
	font-size: 1rem;
	text-transform: uppercase;
	margin: 5px 0 0 0;
	position: relative;
	color: #fff;
}
.main_title_3 h3 strong {
	background-color: #106d88;
	color: #fff;
	text-align: center;
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	-ms-border-radius: 50%;
	border-radius: 50%;
	line-height: 24px;
	display: inline-block;
	width: 24px;
	height: 24px;
	font-size: 14px;
	font-size: 0.875rem;
	margin-right: 10px;
	position: relative;
	top: -2px;
}
.main_title_3 h3:before,
.main_title_3 h3:after {
	content: '';
	position: absolute;
	width: 20px;
	height: 54px;
	bottom: -42px;
	display: block;
	z-index: 9;
}
@media (max-width: 991px) {
	.main_title_3 h3:before,
	.main_title_3 h3:after {
		/* For less than 991px */
		display: none;
	}
}
.main_title_3 h3:before {
	left: 25%;
	/* background: url(../img/arrow_left.png) no-repeat 0 0; */
}
.main_title_3 h3:after {
	right: 25%;
	/* background: url(../img/arrow_right.png) no-repeat 0 0; */
}

.custom-control {
	border-bottom: 1px solid #ccc;
}
.custom-control-label {
	user-select: none;
	width: 100%;
	display: block;
	cursor: pointer;
	padding: 8px;
}
.custom-control-label:before,
.custom-control-label:after {
	margin: 4px;
}
.custom-control-label strong {
	float: right;
}

@media (min-width: 576px) and (max-width: 991px) {
	.box_profile {
		padding: 8px;
	}
	.box_profile_info {
		text-align: left;
	}

	.box_profile_image {
		width: 150px;
		float: left;
	}
	.box_profile_info {
		width: calc(100% - 150px);
		float: left;
	}

	.box_profile ul.contacts {
		border: none;
		padding: 8px 0px;
		margin: 0px;
		text-align: left !important;
	}
}
@media (max-width: 991px) {
	.box_profile figure {
		/* For less than 991px */
		width: 100px;
		height: 100px;
		-webkit-border-radius: 50%;
		-moz-border-radius: 50%;
		-ms-border-radius: 50%;
		border-radius: 50%;
		margin: 12px auto;
	}
}

.donator-badge {
	width: 100%;
	padding: 8px;
	background-color: #87cbc9;
	border-radius: 4px;
}
.donator-badge .stamp-content {
	display: flex;
	align-items: center;
	justify-content: center;
	color: #fff;
}

.donator-badge .stamp-content .donator-stamp {
	background-color: #fff;
	padding: 2px;
	border-radius: 50%;
	border: 2px solid #fff;
	flex-grow: 0;
	flex-shrink: 0;
	margin: 4px;
}

.donator-stamp {
	margin: 4px;
}

.btn-linkedIn {
	background: url(../assets/img/icon-linkedin.png);
	margin: 6px;
	width: 44px;
	height: 44px;
	background-size: contain;
	display: block;
}
/*
.donator-badge .stamp-content p{
    padding: 0px;
    margin: 0px;
    text-align: left;
    padding: 0px 0px 0px 8px;
    color: #fff;
    font-size: 13px;
    line-height: 14px;
}
.donator-badge .active-coupon{
    text-align: center;
    color: #fff;
    padding: 10px 0px 4px 0px;
    border-top: solid 1px #9ad6d4;
    margin-top: 12px;
}
.donator-badge .active-coupon .coupon{
 font-size: 20px;
 font-weight: 600;
} */

.services-table tr {
	border-bottom: solid 1px #f3f3f3;
}
.services-table tr td:first-child {
	padding-left: 18px;
}

.clinic-image {
	max-width: 180px;
}
</style>
